
import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

const MuiTooltip = withStyles((theme) => ({
    tooltip: {
        minHeight: "35px",
        maxWidth: "200px",
        background: "#fff",
        color: "rgba(0, 0, 0, 0.6)",
        border: "1px solid #575757",
        borderRadius: "5px",
        fontWeight: 400,
        fontSize: "14px",
        fontFamily: 'Open Sans'
    },
}))(Tooltip);
const MessageTooltip = (props) => {
  return (
    <MuiTooltip title={props.tooltip} placement={props.placement}>
            <div>{props.children}</div>
    </MuiTooltip>
  )
}

export default MessageTooltip